/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Field_Email_PlaceholderInputs */

const en_auth_field_email_placeholder = /** @type {(inputs: Auth_Field_Email_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`m@example.com`)
};

const pl_auth_field_email_placeholder = /** @type {(inputs: Auth_Field_Email_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`m@przyklad.pl`)
};

/**
* | output |
* | --- |
* | "m@example.com" |
*
* @param {Auth_Field_Email_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const auth_field_email_placeholder = /** @type {((inputs?: Auth_Field_Email_PlaceholderInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Field_Email_PlaceholderInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_auth_field_email_placeholder(inputs)
	return en_auth_field_email_placeholder(inputs)
});